export const INIT = 'INIT';
export const SET_STEP = 'SET_STEP';
export const SET_STEPS = 'SET_STEPS';
export const CUSTOMER_DATA = 'CUSTOMER_DATA';
export const ADVERTISING = 'ADVERTISING';


export function init() {
  return {
    type: INIT
  };
}

export function setStep(step) {
  return {
    type: SET_STEP,
    step
  };
}

export function setSteps(accounts, account) {
  return {
    type: SET_STEPS,
    accounts,
    account
  };
}

export function selectAccountCustomer(crm) {
  return {
    type: CUSTOMER_DATA,
    crm
  };
}

export function selectAccountAdvertising(ad) {
  return {
    type: ADVERTISING,
    ad
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/steps.js